export default __webpack_public_path__ + "locales/lo-LA/Common.json?hash=c60b48f00c5b3b8bdcf2993269924113";